/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialItemDto } from './ReferentialItemDto';
import {
    ReferentialItemDtoFromJSON,
    ReferentialItemDtoFromJSONTyped,
    ReferentialItemDtoToJSON,
    ReferentialItemDtoToJSONTyped,
} from './ReferentialItemDto';

/**
 * Produit porteur du tunnel, réduit à ce qu'affiche le back-office.
 * @export
 * @interface FunnelProduitLightDto
 */
export interface FunnelProduitLightDto {
    /**
     * 
     * @type {string}
     * @memberof FunnelProduitLightDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof FunnelProduitLightDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FunnelProduitLightDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {ReferentialItemDto}
     * @memberof FunnelProduitLightDto
     */
    branche?: ReferentialItemDto;
    /**
     * 
     * @type {number}
     * @memberof FunnelProduitLightDto
     */
    plafondBienImmobilier?: number | null;
}

/**
 * Check if a given object implements the FunnelProduitLightDto interface.
 */
export function instanceOfFunnelProduitLightDto(value: object): value is FunnelProduitLightDto {
    return true;
}

export function FunnelProduitLightDtoFromJSON(json: any): FunnelProduitLightDto {
    return FunnelProduitLightDtoFromJSONTyped(json, false);
}

export function FunnelProduitLightDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FunnelProduitLightDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'libelle': json['libelle'] == null ? undefined : json['libelle'],
        'branche': json['branche'] == null ? undefined : ReferentialItemDtoFromJSON(json['branche']),
        'plafondBienImmobilier': json['plafondBienImmobilier'] == null ? undefined : json['plafondBienImmobilier'],
    };
}

export function FunnelProduitLightDtoToJSON(json: any): FunnelProduitLightDto {
    return FunnelProduitLightDtoToJSONTyped(json, false);
}

export function FunnelProduitLightDtoToJSONTyped(value?: FunnelProduitLightDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'libelle': value['libelle'],
        'branche': ReferentialItemDtoToJSON(value['branche']),
        'plafondBienImmobilier': value['plafondBienImmobilier'],
    };
}

